import { useSite } from '../content/context';
import { Section } from '../content/layout';
import { moveItem, removeItem } from '../edit/list';

/** Read and change the page's section list (changes only apply in the editor). */
export function useSections() {
  const { data, edit } = useSite();
  const layout = data.layout;
  const sections = layout.sections;
  const save = (next: Section[]) => edit?.update('layout', { ...layout, sections: next });

  return {
    sections,
    updateSection: (id: string, patch: Partial<Section>) => save(sections.map((s) => (s.id === id ? { ...s, ...patch } : s))),
    move: (from: number, to: number) => save(moveItem(sections, from, to)),
    remove: (index: number) => save(removeItem(sections, index)),
    insert: (index: number, section: Section) => save([...sections.slice(0, index), section, ...sections.slice(index)]),
  };
}
